import { makeAutoObservable, runInAction } from 'mobx';
import axios from 'axios';
import { IAppStore, IClinicUser } from '../store';

export interface IActivityCycle {
  activeDays: string[];
  end: string;
  start: string;
}

export enum ICareType {
  RESIDENT = 1,
  RESIDENT_RNA = 2,
  RESIDENT_THERAPY = 3,
  HYBRID = 4, // REMOTE_THERAPY_ACTIVE
  ONGOING = 5 // REMOTE_THERAPY_MONITORING
}
export interface IRtmDataRowPatient {
  cases: string[],
  emrId: string,
  fullName: string,
  uuid: string
}

export type CPT75 = '1' | '0' | 'already achieved';

export interface IRtmDataRow {
  activeCycle: IActivityCycle;
  careType: ICareType;
  clinicians: { fullName: string, uuid: string }[];
  coverage: 'RTM' | 'private pay';
  cpt75: CPT75;
  cyclesThatEndedThisMonth: IActivityCycle[];
  daysSinceAdmission: number;
  educationMeetingCount: number;
  monitorEventPerformed: boolean;
  onboardingGoalAchievedInPeriod: boolean;
  patient: IRtmDataRowPatient,
  rtmMinutes: number,
  status: 'new' | 'in progress' | 'discharged'
}

export interface IClinicManagementStore {
  usersNotInClinic: IClinicUser[];
  usersByClinic: IClinicUser[];

  isLoading: boolean;
  rtmList: IRtmDataRow[];

  fetchRtmList(redDate?:string): Promise<void>;
}

export default class ClinicManagementStore implements IClinicManagementStore {
  appStore: IAppStore;
  usersByClinic: IClinicUser[] = [];
  usersNotInClinic: IClinicUser[] = [];

  rtmList: IRtmDataRow[] = [];
  isLoading = false;
  constructor(appStore: IAppStore) {
    makeAutoObservable(this);
    this.appStore = appStore;
  }

  async fetchRtmList(refDate?:string): Promise<void> {
        const rtm = await axios.get<{result:IRtmDataRow[]}>('/api/rtm_control_center/list',{
          params:{
            refDate
          }
        });
        runInAction(()=>{
          this.rtmList = rtm.data.result;
        })
  }
}
